// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"styles__container___Qp8oq","heading":"styles__heading___1-AEq","label-group":"styles__label-group___2drR-","labelGroup":"styles__label-group___2drR-","label":"styles__label___2F6Lz"};
    if(module.hot) {
      // 1771277684701
      var cssReload = require("../../../../../node_modules/extract-css-chunks-webpack-plugin/dist/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}","cssModules":true});
      module.hot.dispose(cssReload);
      ;
    }
  